export const environment = {
	production: true
};
export interface Environment {
	endPoint: string;
	commonEndPoint: string;
	siteKey: string;
	imageLink: string;
	websiteLink: string;
	mapKey: string;
}
let envObj = {
	endPoint: 'https://app.cosmossurfaces.com/api/v1/',
	commonEndPoint: 'https://common.cosmossurfaces.com/api/',
	siteKey: '6Levfz8pAAAAAGOhjxPUrUZc8cCn_lX4SHW7rzV2',
	// endPoint:'https://staging.cosmosgranite.com/api/',
	imageLink: 'https://staging.cosmosgranite.com/',
	websiteLink: 'https://staging.quartz.cosmosgranite.com',
	mapKey: 'AIzaSyCMnUw7FLREKH9UnQfsWocQUfyQiE5MNQo'
}
if ((window.location.href.indexOf('staging.quartz.cosmosgranite') != -1) || (window.location.href.indexOf('localhost') != -1)) {
	envObj = {
		endPoint: 'https://uat-backend.cosmossurfaces.com/api/v1/',
		commonEndPoint: 'https://common.cosmossurfaces.com/api/',
		siteKey: '6LdNfAgaAAAAAClk7HhJpE4Gk2GsIqI9Eo1G8Jn3',
		// endPoint:'https://staging.cosmosgranite.com/api/',
		imageLink: 'https://staging.cosmosgranite.com/',
		websiteLink: 'https://staging.quartz.cosmosgranite.com',
		mapKey: 'AIzaSyCECNx6YKAjaYfP9Eq7FXAMB1QmjUKvMZk'
	}
}


export const PROD: Environment = envObj

export const environment1: Environment = PROD;
